import breakPoints from 'helpers/Styles';

const RangesColumnsSeries = ({ block, primaryFontColor, secondaryFontColor }) => {
  if (!block) return '';

  const { title1, subtitle } = block.primary;
  const title = title1 ? title1 : null;
  const subTitle = subtitle ? subtitle : null;

  const { items } = block;

  return (
    <>
      <div className="ranges_columns_series wrapper">
        <div className="title">
          <p>{title}</p>
          <h1>{subTitle}</h1>
        </div>

        <div className="columns_information">
          <div className="information_container">
            {items &&
              items.map((item, index) => (
                <div key={index} className="column_container">
                  <div className="column_information">
                    <img draggable="false"  src={item.image.url} alt="column_information" />
                    <p>{item.range_title}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .ranges_columns_series {
            background: inherit;
            padding: 60px 20px;
            padding-bottom: 100px;
          }
          .columns_information {
            display: flex;
            width: 100%;
            margin: 0 auto;
          }
          .information_container {
            display: flex;
            width: 100%;
            justify-content: space-between;
            width: 80%;
            margin: 0 auto;
          }
          .column_information {
            width: 100%;
            text-align: center;
          }
          .title p {
            color: ${primaryFontColor ? primaryFontColor : ''};
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            margin: 0;
            margin-bottom: 20px;
          }
          .title h1 {
            color: ${secondaryFontColor ? secondaryFontColor : ''};
            font-family: 'big_noodle_titling';
            font-size: 39px;
            letter-spacing: 0;
            line-height: 48px;
            text-align: center;
            margin: 0;
            margin-bottom: 40px;
          }
          .column_container {
            width: 25%;
            display: flex;
            justify-content: center;
          }
          .column_container p {
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            margin-left: 10px;
          }
          @media (max-width: ${breakPoints.small}) {
            .title h1 {
              font-size: 26px;
            }
            .information_container {
              justify-content: center;
              flex-wrap: wrap;
              width: 80%;
            }
            .column_container {
              width: 50%;
            }
            .column_information {
              margin-bottom: 20px;
            }
          }
        `}
      </style>
    </>
  );
};

export default RangesColumnsSeries;
